import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconVMark } from '../../../../assets/icons/svg/shared/ic-shared-checkmark-circle.svg';

export const UnlinkAccountToast = () => {
  const { t } = useTranslation();
  return (
    <div className='bg-bw08 items-center justify-center flex' data-testid='UnlinkAccountToast'>
      <IconVMark className='stroke-bw00 w-[20px] h-[20px] mr-[8px]' />
      <div className='font-metricR text-md text-bw00'>{t('SEND_MONEY.TOASTS.UNLINK_ACCOUNT_SUCCESS')}</div>
    </div>
  );
};
